module.exports = __webpack_public_path__ + "img/ico033.731bdea2.svg";